<ion-header>
  <ion-toolbar>
    <ion-title>Add Bottle</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [formGroup]="form">
  <ion-card class="ion-no-padding">
    <ion-item lines="none">
      @if (bottles) {
        <ion-select
          label="Select Size"
          labelPlacement="floating"
          formControlName="selectBottle"
          (ionChange)="selectItem($event)"
          placeholder="Select size"
          interface="popover"
          data-testid="new-bottle-size-select"
          #addKegSelectList
          >
          @for (bottle of bottles; track bottle) {
            <ion-select-option [value]="bottle">
              {{ bottle.name }}
            </ion-select-option>
          }
        </ion-select>
      }
    </ion-item>
  </ion-card>
</ion-content>
